
/**
 * Formats a phone number string into a readable format
 * Supports various input formats and returns a consistent output
 */
export const formatPhoneNumber = (phone: string | null | undefined): string => {
  if (!phone) return "Unknown Customer";
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Handle different phone number lengths
  if (cleaned.length === 10) {
    // US phone number: (123) 456-7890
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
    // US phone number with country code: +1 (123) 456-7890
    return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  } else if (cleaned.length >= 7) {
    // For other formats, just add basic formatting
    const areaCode = cleaned.slice(0, 3);
    const prefix = cleaned.slice(3, 6);
    const suffix = cleaned.slice(6);
    return `(${areaCode}) ${prefix}-${suffix}`;
  }
  
  // Return original if it doesn't match expected patterns
  return phone;
};

/**
 * Validates if a phone number appears to be valid
 */
export const isValidPhoneNumber = (phone: string | null | undefined): boolean => {
  if (!phone) return false;
  
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length >= 10 && cleaned.length <= 11;
};
